import { TableSettingsFieldsTabType, TableSettingsTabType } from '@doss/common-all'
import { TranslationKeys } from '../../common/generated/i18n.generated'

export const DEFAULT_TAB = TableSettingsTabType.CONFIGURATION
export const DEFAULT_FIELDS_TAB = TableSettingsFieldsTabType.ALL_FIELDS

export const GROUP_DISPLAY_LIMIT = 8

export enum AllFieldsColumnType {
  NAME = 'name',
  TYPE = 'type',
  REQUIRED = 'required',
  HIDDEN = 'hidden',
  GROUP = 'group',
  CONFIG = 'config',
  DESCRIPTION = 'description',
}

export const ALL_FIELDS_COLUMNS = (t: (key: TranslationKeys) => string) => [
  {
    id: AllFieldsColumnType.NAME,
    name: t('table.settings.name'),
    type: 'string',
    width: 250,
  },
  {
    id: AllFieldsColumnType.TYPE,
    name: t('table.settings.type'),
    type: 'singleSelect',
    width: 140,
  },
  {
    id: AllFieldsColumnType.DESCRIPTION,
    name: 'Description',
    type: 'string',
    width: 200,
  },
  { id: AllFieldsColumnType.REQUIRED, name: t('table.settings.required'), type: 'boolean' },
  { id: AllFieldsColumnType.CONFIG, name: 'Config', type: 'string', width: 200 },
  { id: AllFieldsColumnType.HIDDEN, name: t('table.settings.hidden'), type: 'boolean' },
  { id: AllFieldsColumnType.GROUP, name: t('table.settings.group'), type: 'string', width: 140 },
]

export const CHILD_TABLE_FIELDS_COLUMNS = (t: (key: TranslationKeys) => string) => [
  {
    id: AllFieldsColumnType.NAME,
    name: t('table.settings.name'),
    type: 'string',
    width: 300,
  },
  {
    id: AllFieldsColumnType.TYPE,
    name: t('table.settings.type'),
    type: 'singleSelect',
    width: 250,
  },
  { id: AllFieldsColumnType.REQUIRED, name: t('table.settings.required'), type: 'boolean' },
]

export const GROUP_FIELDS_COLUMNS = (t: (key: TranslationKeys) => string) => [
  {
    id: AllFieldsColumnType.NAME,
    name: t('table.settings.name'),
    type: 'string',
    width: 300,
  },
  {
    id: AllFieldsColumnType.TYPE,
    name: t('table.settings.type'),
    type: 'singleSelect',
    width: 250,
  },
  { id: AllFieldsColumnType.REQUIRED, name: t('table.settings.required'), type: 'boolean' },
]

// The desired order of table column type options based on their human-readable names
export const ORDERED_OPTIONS = (t: (key: TranslationKeys) => string) => [
  t('table.create_column.human_readable_types.string'),
  t('table.create_column.human_readable_types.number'),
  t('table.create_column.human_readable_types.date'),
  t('table.create_column.human_readable_types.date_time'),
  t('table.create_column.human_readable_types.enum'),
  t('table.create_column.human_readable_types.array_enum'),
  t('table.create_column.human_readable_types.file_url'),
  t('table.create_column.human_readable_types.array_file_url'),
  t('table.create_column.human_readable_types.id'),
  t('table.create_column.human_readable_types.boolean'),
  t('table.create_column.human_readable_types.formula'),
  t('table.create_column.human_readable_types.lookup'),
  t('table.create_column.human_readable_types.array_lookup'),
  t('table.create_column.human_readable_types.user'),
  t('table.create_column.human_readable_types.array_user'),
]

// Create a Map for quicker lookup. This maps the human-readable table column option name
// to its sort order.
export const orderLookup = (t: (key: TranslationKeys) => string) =>
  new Map(ORDERED_OPTIONS(t).map((name, index) => [name, index]))

export enum RightPanelOperation {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum RightPanelObjectType {
  TABLE_COLUMN = 'tableColumn',
  CHILD_TABLE = 'childTable',
  COLUMN_GROUP = 'columnGroup',
  BUTTON_NODE = 'buttonNode',
  BUTTON_TRANSITION = 'buttonTransition',
  WORKSPACE_BUTTON = 'workspaceButton',
  ROW_BUTTON_NODES = 'rowButtonNodes',
}

export const CONDITION_GUIDE_URL =
  'https://www.notion.so/doss-com/Formula-Guide-b94c86fb3fab43bd93628ea51d74901e?source=copy_link#e06eadc3af304e3794373f6b0748d930'
